// src/config.js
const config = {
  BASE_URL: "https://apis.infohairgram.com/apis/", // <-- replace with your actual backend API base URL
};

export default config;
